// extracted by mini-css-extract-plugin
export default {"two-column-list":"BPServiceSelectionPopup_two-column-list__6Zlbl"};